"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _textItalic = _interopRequireDefault(require("@atlaskit/icon/core/text-italic"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorItalicIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2M8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m4-8h2l-2 8h-2z"/></svg>`
}, props, {
  newIcon: _textItalic.default
}));
EditorItalicIcon.displayName = 'EditorItalicIcon';
var _default = exports.default = EditorItalicIcon;